import React, { useEffect, useState, useContext } from 'react'
import { useTranslation } from "react-i18next"
import './crudParentChildTable.css'
import { Close } from '@mui/icons-material'
import { DataTable } from 'primereact/datatable/datatable.cjs.js'
import { Column } from 'primereact/column/column.cjs.js'
import { InputText } from 'primereact/inputtext/inputtext.cjs.js'
import { InputNumber } from 'primereact/inputnumber/inputnumber.cjs.js';
import { LoadingContext, BufferService, NavigateContext, M_Select, M_MessageBoard, M_Button, M_DrawerTableTextField, M_InputTextField, M_StateActions } from '../../../M_Components'
import { useDispatch, useSelector } from 'react-redux'

export function CrudParentChildTable({ }) {
    const dispatch = useDispatch()
    const M_State = useSelector(state => state.StateKeyValue)

    const [id, setId] = useState(M_State.filter(obj => obj.key === 'selectedTab')[0]?.value)
    const operation = 'Create'
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const { t } = useTranslation()

    const ReduxStoreInfo = M_State.filter(obj => obj.key === 'crudDoubleTable')[0]?.value
    const [parentEntity, setParentEntity] = useState(ReduxStoreInfo?.parent || '')
    const [childEntity, setChildEntity] = useState(ReduxStoreInfo?.child || '')
    const [entityField, setEntityField] = useState(ReduxStoreInfo?.field || '')
    dispatch(M_StateActions.removeM_State({ key: 'crudDoubleTable' }))

    const ReduxStoreConfirmation = M_State.filter(obj => obj.key === 'hasConfirmation')[0]?.value
    const [hasConfirmation, setHasConfirmation] = useState(ReduxStoreConfirmation ? ReduxStoreConfirmation : false)
    dispatch(M_StateActions.removeM_State({ key: 'hasConfirmation' }))

    const [parentFields, setParentFields] = useState([])
    const [childFields, setChildFields] = useState([])
    const [tab, setTab] = useState('Parent')
    const [valueMap, setValueMap] = useState(new Map())
    const [childMap, setChildMap] = useState(new Map())
    const [childObj, setChildObj] = useState([])
    const [companies, setCompanies] = useState([])
    const [isFirst, setIsFirst] = useState(true)
    const parentService = new BufferService(parentEntity)
    const childService = new BufferService(childEntity)
    const validateService = new BufferService(`${parentEntity}/validate`)
    const [openMessage, setOpenMessage] = useState(false)
    const [message, setMessage] = useState('')

    useEffect(() => {
        if (isFirst) {
            getSessionStorageData(id)
            setIsFirst()
        }
    }, [])

    const sessionKeys = ['parentEntity', 'childEntity', 'entityField', 'parentFields', 'childFields', 'tab', 'valueMap', 'childMap', 'childObj', 'companies', 'hasConfirmation']

    useEffect(() => {
        const newId = M_State.filter(obj => obj.key === 'selectedTab')[0]?.value

        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    const sessionStorageMachine = (id, key, value) => {
        let tempObj = {}
        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (Array.from(eval(value))) }
        } else {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (eval(value)) }
        }
        return tempObj
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const M_StateData = M_State.filter(obj => obj.key === sessionID)[0]?.value
        if (M_StateData) {

            const tempPE = M_StateData?.filter(obj => obj.key === `parentEntity`)[0]?.value
            const tempCE = M_StateData?.filter(obj => obj.key === `childEntity`)[0]?.value
            const tempEF = M_StateData?.filter(obj => obj.key === `entityField`)[0]?.value
            const tempPF = M_StateData?.filter(obj => obj.key === `parentFields`)[0]?.value
            const tempCF = M_StateData?.filter(obj => obj.key === `childFields`)[0]?.value
            const tempT = M_StateData?.filter(obj => obj.key === `tab`)[0]?.value
            const tempVM = M_StateData?.filter(obj => obj.key === `valueMap`)[0]?.value
            const tempCM = M_StateData?.filter(obj => obj.key === `childMap`)[0]?.value
            const tempCO = M_StateData?.filter(obj => obj.key === `childObj`)[0]?.value
            const tempC = M_StateData?.filter(obj => obj.key === `companies`)[0]?.value
            const tempHC = M_StateData?.filter(obj => obj.key === `hasConfirmation`)[0]?.value

            if (tempPE || tempCE || tempEF || tempPF || tempCF || tempT || tempVM || tempCM || tempCO || tempC || tempHC) {
                setParentEntity(tempPE)
                setChildEntity(tempCE)
                setEntityField(tempEF)
                setParentFields(tempPF)
                setChildFields(tempCF)
                setTab(tempT)
                setValueMap(new Map(tempVM))
                setChildMap(new Map(tempCM))
                setChildObj(tempCO)
                setCompanies(tempC)
                setHasConfirmation(tempHC)
                ctx.setIsLoad(false)
                return
            }
        }
        ctx.setIsLoad(false)
        get()
    }

    useEffect(() => {
        const tempArray = []
        sessionKeys.forEach((key) => {
            tempArray.push(sessionStorageMachine(id, key, key))
        })
        dispatch(M_StateActions.addM_State({ key: id, value: tempArray }))
        // eslint-disable-next-line
    }, [parentEntity, childEntity, entityField, parentFields, childFields, tab, valueMap, childMap, childObj, companies, hasConfirmation])

    const get = () => {

        if (operation === 'Create') {
            parentService.options().then((data) => {
                const tempMap = new Map()
                const tempParentArray = []
                data.forEach(i => {
                    if (!i.IsHiddenEdit) {
                        tempParentArray.push(i)
                        tempMap.set(i.Name, '')
                    }
                })
                setParentFields(tempParentArray)

                childService.options().then((data) => {
                    const tempChildArray = []
                    data.forEach(i => {
                        if (!i.IsHiddenEdit) {
                            tempChildArray.push(i)
                            tempMap.set(i.Name, '')
                        }
                    })
                    setChildFields(tempChildArray)
                    const companies = M_State.filter(obj => obj.key === 'companies')[0]?.value

                    if (companies.length == 1) {
                        valueMap.set('UserCompanyId', companies[0].Id)
                        setValueMap(new Map(valueMap))
                    }
                    setCompanies(companies.map((tempComp) => {
                        return { label: tempComp.Code, value: tempComp.Id }
                    }))
                })
            })
        }
    }

    const cleanUp = () => {
        refreshCrud()
        ctx2.closeTab(id)
    }

    const refreshCrud = () => {
        parentFields.forEach(elemParent => {
            valueMap.set(elemParent.Name, '')
        })
        childFields.forEach(elemChild => {
            childMap.set(elemChild.Name, '')
        })
        setValueMap(new Map(valueMap))
        setChildMap(new Map(childMap))
        setChildObj([])
    }

    const submitValues = () => {
        ctx.setIsLoad(true)

        const parentObj = Object.fromEntries(valueMap)

        if (hasConfirmation) {
            validateService.post(parentObj).then(valData => {
                if (valData.name === 'AxiosError') {
                    if (Array.isArray(valData?.response?.data?.Errors)) {
                        ctx.toastMessages('error', valData?.response?.data?.Errors.toString(), 'Erro, ')
                    } else {
                        ctx.toastMessages('error', valData?.response?.data, 'Erro, ')
                    }
                    ctx.setIsLoad(false)
                    return
                }
                if (Object.keys(valData)[0] === 'NEEDS_VALIDATION') {
                    setMessage(Object.values(valData)[0])
                    setOpenMessage(true)
                    ctx.setIsLoad(false)
                }
                if (Object.keys(valData)[0] === 'CAN_CREATE') {
                    submitCall()
                }
                if (Object.keys(valData)[0] === 'CANT_CREATE') {
                    ctx.toastMessages('error', '', Object.values(valData)[0])
                    ctx.setIsLoad(false)
                }
            })
        } else {
            submitCall()
        }

    }

    const submitCall = () => {
        const parentObj = Object.fromEntries(valueMap)
        const childArray = childObj

        parentService.post(parentObj).then(data => {
            if (data.name === 'AxiosError') {
                if (Array.isArray(data?.response?.data?.Errors)) {
                    ctx.toastMessages('error', data?.response?.data?.Errors.toString(), 'Erro, ')
                } else {
                    ctx.toastMessages('error', data?.response?.data, 'Erro, ')
                }
                ctx.setIsLoad(false)
                return
            }
            if (childArray.length === 0) {

                const tempChil = Object.fromEntries(childMap)
                tempChil[entityField] = data.Id
                childService.post(tempChil).then(childData => {
                    if (childData.name === 'AxiosError') {
                        if (Array.isArray(childData?.response?.data?.Errors)) {
                            ctx.toastMessages('error', childData?.response?.data?.Errors.toString(), 'Erro, ')
                        } else {
                            ctx.toastMessages('error', childData?.response?.data, 'Erro, ')

                        }
                        ctx.setIsLoad(false)
                        return
                    }
                    ctx.setIsLoad(false)
                    ctx.toastMessages('success', '', t("AddSuccess"))
                    refreshCrud()
                    ctx2.closeTab(id)
                })

            } else {

                childArray.forEach(childElem => {
                    childElem[entityField] = data.Id
                    childService.post(childElem).then(childData => {
                        if (childData.name === 'AxiosError') {
                            if (Array.isArray(childData?.response?.data?.Errors)) {
                                ctx.toastMessages('error', childData?.response?.data?.Errors.toString(), 'Erro, ')
                            } else {
                                ctx.toastMessages('error', childData?.response?.data, 'Erro, ')

                            }
                            ctx.setIsLoad(false)
                            return
                        } else {
                            ctx.setIsLoad(false)
                            ctx.toastMessages('success', '', t("AddSuccess"))
                            refreshCrud()
                            ctx2.closeTab(id)
                        }
                    })
                })
            }
        })
    }

    const addValue = (value, code, map, setMap) => {
        map.set(code, value)
        setMap(new Map(map))
    }

    const addChildTable = () => {
        const tempObj = Object.fromEntries(childMap)

        childFields.forEach(fields => {
            childMap.set(fields.Name, '')
        })
        if (childObj.length) {
            const newId = childObj[childObj.length - 1].Id
            tempObj.Id = newId + 1
        } else {
            tempObj.Id = 1
        }
        setChildObj(prev => [...prev, tempObj])
        setChildMap(new Map(childMap))

    }

    const editTable = (data, value, code) => {
        let tempObj = data
        tempObj[code] = value
        setChildObj(childObj.map(obj => {
            if (obj.Id === data.Id) {
                return tempObj
            }
            else return obj
        }))
    }

    const deleteRow = (value) => {
        const tempArray = childObj.filter(elem => elem.Id !== value.Id)
        setChildObj(tempArray)
    }


    return (
        <div style={{ backgroundColor: 'var(--color-white)', position: 'sticky', top: '250px' }}>
            <div style={{ borderBottom: '1px solid var(--color-grey)', backgroundColor: 'var(--color-white)', width: '100%', display: 'flex', height: '45px', alignItems: 'center', padding: '5px' }}>
                <div style={{ display: 'flex', alignItems: 'center', textAlign: 'center', left: '0', height: '35px' }}>
                    <M_Button
                        tooltip={t("Close")}
                        label={<b>{t("Close")}</b>}
                        icon={<i className="pi pi-arrow-left iconTable" style={{ color: ctx.secondaryColor }}></i>}
                        onClick={() => cleanUp()}
                    />
                    <M_Button
                        tooltip={t("RefreshTable")}
                        label={<b>{operation === 'Create' ? t("Reset") : t("Refresh")}</b>}
                        icon={<i className="pi pi-refresh iconTable"></i>}
                        onClick={() => refreshCrud()}
                    />
                    {operation === 'Create' || operation === 'Copy' ?
                        <M_Button
                            tooltip={t("Save")}
                            label={<b>{t("Save")}</b>}
                            icon={<i className="pi pi-save iconTable"></i>}
                            onClick={() => { if (operation === 'Create' || operation === 'Copy') submitValues() }}
                        />
                        : ''
                    }
                </div>
            </div >
            <div >
                <div style={{ display: 'flex', margin: '5px 20px', justifyContent: 'space-evenly' }}>

                    <div
                        className={`cardParentChildCrud ${tab === 'Parent' && 'active'}`}
                        onClick={() => setTab('Parent')}
                    >
                        <h4>{parentEntity}</h4>
                    </div>
                    <div
                        className={`cardParentChildCrud ${tab === 'Child' && 'active'}`}
                        onClick={() => setTab('Child')}
                    >
                        <h4>{childEntity}</h4>
                    </div>
                </div>

                {tab === 'Parent' && <div id='PARENT'>
                    <div style={{ justifyContent: 'inherit', display: 'grid', gridTemplateColumns: 'auto auto auto auto', paddingTop: '20px' }} >
                        {parentFields.map((data, index) => (
                            <div key={index} style={{ width: '100%', padding: '20px 40px 0px 40px' }}>
                                {data.Name === 'UserCompanyId' ?
                                    <M_Select
                                        label={'User Company'}
                                        value={valueMap.get(data.Name) || ''}
                                        options={companies}
                                        color={!valueMap.get(data.Name) ? 'var(--color-red)' : ''}
                                        secondColor={!valueMap.get(data.Name) ? 'var(--color-red)' : ''}
                                        required={true}
                                        onChange={(e) => addValue(e.target.value, data.Name, valueMap, setValueMap)}
                                    />
                                    : data.IsForeignKey ?
                                        <M_DrawerTableTextField
                                            label={data.NormalizedName}
                                            value={valueMap.get(data.Name) || ''}
                                            entity={data.ForeignTableName}
                                            fieldName={data.ForeignKeyName}
                                            required={data.IsRequired}
                                            color={data.IsRequired && !valueMap.get(data.Name) ? 'var(--color-red)' : ''}
                                            secondColor={data.IsRequired && !valueMap.get(data.Name) ? 'var(--color-red)' : ''}
                                            onValueChange={(e) => { }}
                                            onSaveId={(e) => addValue(e, data.ForeignTableToPassId, valueMap, setValueMap)}
                                            extraFields={[data.ForeignKeyName]}
                                            onExtraFields={(e) => {
                                                addValue(e.get(data.ForeignKeyName), data.Name, valueMap, setValueMap)
                                            }}
                                            tableLabel={data.ForeignTableName}
                                        />
                                        :
                                        <M_InputTextField
                                            label={data.NormalizedName}
                                            type={data.Type}
                                            value={valueMap.get(data.Name) || ''}
                                            onChange={(e) => addValue(e.target.value, data.Name, valueMap, setValueMap)}
                                            required={data.IsRequired}
                                            color={data.IsRequired && !valueMap.get(data.Name) ? 'var(--color-red)' : ''}
                                            secondColor={data.IsRequired && !valueMap.get(data.Name) ? 'var(--color-red)' : ''}
                                        />
                                }
                            </div>
                        ))
                        }
                    </div>
                </div>}
                {tab === 'Child' && <div id='CHILD'>
                    <div style={{ justifyContent: 'inherit', display: 'grid', gridTemplateColumns: 'auto auto auto auto', paddingTop: '20px' }} >
                        {childFields.map((data, index) => (
                            <div key={index} style={{ width: '100%', padding: '20px 40px 0px 40px' }}>
                                <M_InputTextField
                                    label={data.NormalizedName}
                                    value={childMap.get(data.Name) || ''}
                                    required={data.IsRequired}
                                    type={data.Type}
                                    color={data.IsRequired && !childMap.get(data.Name) ? 'var(--color-red)' : ''}
                                    secondColor={data.IsRequired && !childMap.get(data.Name) ? 'var(--color-red)' : ''}
                                    onChange={(e) => addValue(e.target.value, data.Name, childMap, setChildMap)}
                                />
                            </div>
                        ))
                        }
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'right', margin: '0px 40px 10px 40px', paddingBottom: '10px', borderBottom: '1px solid var(--color-grey)' }}>
                        <M_Button
                            normal
                            hoverEffect
                            label={'Add'}
                            backgroundColor={'var(--color-green)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => { addChildTable() }}
                        />
                    </div>
                    <div style={{ margin: '0px 20px' }}>
                        <DataTable value={childObj} size={'small'} >
                            {childFields.map((tableElem, index) => (
                                <Column key={index} field={tableElem.Name} header={tableElem.NormalizedName} body={(tableValue) => {
                                    if (tableElem.Type === 'string') {
                                        return <InputText
                                            className="p-inputtext-sm"
                                            style={{ borderColor: 'var(--color-white)' }}
                                            value={tableValue[tableElem.Name]}
                                            onChange={(e) => editTable(tableValue, e.target.value, tableElem.Name)}
                                        />
                                    } else
                                        if (tableElem.Type === 'int32') {
                                            <InputNumber
                                                className="p-inputtext-sm"
                                                style={{ borderColor: 'var(--color-white)' }}
                                                value={tableValue[tableElem.Name]}
                                                onChange={(e) => editTable(tableValue, e.target.value, tableElem.Name)}
                                            />
                                        } else {
                                            return <div>{tableValue[tableElem.Name] || ''}</div>
                                        }
                                }} />
                            ))}
                            <Column style={{ maxWidth: '50px' }} body={(data) => {
                                return <Close className='cursorPointer' onClick={() => deleteRow(data)} />
                            }} />

                        </DataTable>

                    </div>
                </div>}
            </div>
            <br /><br /><br /><br /><br />
            <M_MessageBoard
                open={openMessage}
                onClose={() => setOpenMessage(false)}
                title={'Confirmation Message'}
                body={message}
                footer={
                    <div style={{ display: 'flex' }}>
                        <M_Button
                            normal
                            hoverEffect
                            label={t('ButtonConfirm')}
                            backgroundColor={'var(--color-green)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => {
                                setOpenMessage(false)
                                submitCall()
                            }}
                        />
                        <M_Button
                            normal
                            hoverEffect
                            label={t('ButtonCancel')}
                            backgroundColor={'var(--color-red)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => setOpenMessage(false)}
                        />
                    </div>
                }
            />
        </div>
    )
}

